import React, { useState, useEffect } from 'react';

export default function PatientForm({ patient, onSave, onCancel }) {
  const [form, setForm] = useState({
    name: '',
    prenom: '',
    sexe: '',
    dateNaissance: '',
    dateInscription: new Date().toISOString().slice(0, 10),
    age: '',
    phone: '',
    adresse: '',
    insuranceName: '',
    insuranceNumber: '',
    nomMere: '',
    nomJeuneFille: '',
    etatCivil: '',
    orientedService: '',
    signesVitaux: { ta: '', temp: '', fc: '', fr: '', poids: '', taille: '' },
    infirmiereSignature: ''
  });

  const serviceOptions = ['Médecine interne', 'Gynécologie/Obstétrique', 'Ophtalmologie', 'Pédiatrie', 'Chirurgie', 'ORL', 'Dermatologie', 'Cardiologie', 'Urgences'];

  useEffect(() => {
    if (patient) setForm({
      name: patient.name || '',
      prenom: patient.prenom || '',
      sexe: patient.sexe || '',
        dateNaissance: patient.dateNaissance || '',
      dateInscription: patient.dateInscription || new Date().toISOString().slice(0, 10),
      age: patient.age || '',
      phone: patient.phone || '',
      adresse: patient.adresse || '',
      insuranceName: patient.insurance?.name || patient.insuranceName || '',
      insuranceNumber: patient.insurance?.memberNumber || patient.insuranceNumber || '',
      nomMere: patient.nomMere || '',
      nomJeuneFille: patient.nomJeuneFille || '',
      etatCivil: patient.etatCivil || '',
      orientedService: patient.orientedService || '',
      signesVitaux: patient.signesVitaux || { ta: '', temp: '', fc: '', fr: '', poids: '', taille: '' },
      infirmiereSignature: patient.infirmiereSignature || '',
      id: patient.id,
      code: patient.code || ''
    });
  }, [patient]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSignesChange = (e) => setForm({ ...form, signesVitaux: { ...form.signesVitaux, [e.target.name]: e.target.value } });

  const submit = (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      age: form.age ? Number(form.age) : undefined
    };
    onSave(payload);
  };

  return (
    <form onSubmit={submit} className="patient-form" style={{ border: '1px solid #ccc', padding: 12, marginTop: 12 }}>
      <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
        <div>
          <label>Nom :</label>
          <input name="name" value={form.name} onChange={handleChange} required />
        </div>
        <div>
          <label>Prénom:</label>
          <input name="prenom" value={form.prenom} onChange={handleChange} />
        </div>
        <div>
          <label>Sexe:</label>
          <select name="sexe" value={form.sexe} onChange={handleChange}>
            <option value="">—</option>
            <option value="F">Femme</option>
            <option value="M">Homme</option>
            <option value="O">Autre</option>
          </select>
        </div>
        <div>
          <label>Date de naissance:</label>
          <input name="dateNaissance" value={form.dateNaissance} onChange={handleChange} type="date" />
        </div>
        <div>
          <label>Date d'inscription:</label>
          <input name="dateInscription" value={form.dateInscription} onChange={handleChange} type="date" />
        </div>
        <div>
          <label>Âge:</label>
          <input name="age" value={form.age} onChange={handleChange} type="number" />
        </div>
        <div>
          <label>Téléphone:</label>
          <input name="phone" value={form.phone} onChange={handleChange} />
        </div>
      </div>

      <div className="form-row" style={{ marginTop: '10px' }}>
        <label>Adresse:</label>
        <textarea name="adresse" value={form.adresse} onChange={handleChange} rows={2} />
      </div>

      <fieldset style={{ marginTop: '16px', padding: '14px', borderRadius: '10px', border: '1px solid #ddd' }}>
        <legend>Assurance</legend>
        <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
          <div><label>Nom de l'assurance</label><input name="insuranceName" value={form.insuranceName} onChange={handleChange} placeholder="Ex. OFATMA" /></div>
          <div><label>Numéro d'adhérent</label><input name="insuranceNumber" value={form.insuranceNumber} onChange={handleChange} placeholder="Numéro de prise en charge" /></div>
        </div>
        {form.insuranceName && <div style={{ marginTop: '8px', color: '#475569' }}>Un code assurance unique sera créé automatiquement.</div>}
      </fieldset>

      <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', marginTop: '12px' }}>
        <div>
          <label>Nom de la mère:</label>
          <input name="nomMere" value={form.nomMere} onChange={handleChange} />
        </div>
        <div>
          <label>Nom de jeune fille:</label>
          <input name="nomJeuneFille" value={form.nomJeuneFille} onChange={handleChange} />
        </div>
        <div>
          <label>État civil:</label>
          <select name="etatCivil" value={form.etatCivil} onChange={handleChange}>
            <option value="">—</option>
            <option value="celibataire">Célibataire</option>
            <option value="marie">Marié(e)</option>
            <option value="divorce">Divorcé(e)</option>
            <option value="veuf">Veuf/Veuve</option>
          </select>
        </div>
      </div>

      <div style={{ marginTop: '16px' }}>
        <label>Orienter vers le service :</label>
        <select name="orientedService" value={form.orientedService} onChange={handleChange} style={{ display: 'block', width: '100%', padding: '8px', marginTop: '6px' }}>
          <option value="">— Sélectionner un service —</option>
          {serviceOptions.map(service => <option key={service} value={service}>{service}</option>)}
        </select>
        <small style={{ color: '#64748b' }}>Le patient sera envoyé au médecin traitant du service choisi pour la consultation.</small>
      </div>

      <fieldset style={{ marginTop: '18px', padding: '14px', borderRadius: '10px', border: '1px solid #ddd' }}>
        <legend>Signes vitaux</legend>
        <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(6, minmax(120px, 1fr))', alignItems: 'end' }}>
          <div>
            <label>Tension artérielle</label>
            <input name="ta" value={form.signesVitaux.ta} onChange={handleSignesChange} placeholder="12/8" />
          </div>
          <div>
            <label>Température</label>
            <input name="temp" value={form.signesVitaux.temp} onChange={handleSignesChange} placeholder="37.2" />
          </div>
          <div>
            <label>FC</label>
            <input name="fc" value={form.signesVitaux.fc} onChange={handleSignesChange} placeholder="78" />
          </div>
          <div>
            <label>FR</label>
            <input name="fr" value={form.signesVitaux.fr} onChange={handleSignesChange} placeholder="18" />
          </div>
          <div>
            <label>Poids</label>
            <input name="poids" value={form.signesVitaux.poids} onChange={handleSignesChange} placeholder="kg" />
          </div>
          <div>
            <label>Taille</label>
            <input name="taille" value={form.signesVitaux.taille} onChange={handleSignesChange} placeholder="cm" />
          </div>
        </div>
      </fieldset>

      <div style={{ marginTop: '16px' }}>
        <label>Signature infirmière</label>
        <input name="infirmiereSignature" value={form.infirmiereSignature} onChange={handleChange} placeholder="Nom de l'infirmière" />
      </div>

      <div className="actions" style={{ marginTop: '18px' }}>
        <button type="submit">Enregistrer</button>
        <button type="button" onClick={onCancel} style={{ marginLeft: 8 }}>Annuler</button>
      </div>
    </form>
  );
}
